import Popup from 'reactjs-popup';
import Select from 'react-select'
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom';
import moment from 'moment';
import { WTPQuantityOfWaterPostDataAPI } from '../../../../../../Redux/WTPDashboardSlice/WTPDashboardsSlice/DataUploadSlice/QuantityOfWaterSlice';
import { useAuthState } from '../../../../../../Helper/Context';
import { useDispatch } from 'react-redux';
import { Loading } from '../../../../../../Helper/Loading';


export default function WTPQuantityOfWaterPagePopup(props) {

    const { handleOnCloseClick, open, Flag, handleIsPost, apiFlag, rowData, } = props

    const userDetails = useAuthState();
    const { year, setYear, Month, setMonth, Ward, setWard, CurrentYear, CurrentMonth } = userDetails
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let HYear = searchParams.get("Year")
    let HMonth = searchParams.get("Month")

    // const [ReadingData, setReadingData] = useState(moment().format('YYYY-MM-DD'))

    const [ReadingData, setReadingData] = useState()

    const monthId = moment(ReadingData).month() + 1;

    const [QuantityOfWaterInputField, setQuantityOfWaterInputField] = useState({
        rawWaterReceivedFromDam: Flag === 'Update' ? rowData.rawWaterReceivedFromDam : '',
        rawWaterSuppliedToMJP: Flag === 'Update' ? rowData.rawWaterSuppliedToMJP : '',
        netRawWaterSuppliedToNMMC: Flag === 'Update' ? rowData.netRawWaterSuppliedToNMMC : '',
        treatmentLossInMLD: Flag === 'Update' ? rowData.treatmentLossInMLD : '',
        quantityofPureWater: Flag === 'Update' ? rowData.quantityofPureWater : ''
    });

    const handleInputChange = (e) => {
        setQuantityOfWaterInputField({ ...QuantityOfWaterInputField, [e.target.name]: e.target.value })
    }

    const [loading, setloading] = useState(false)

    const handleSubmit = () => {
        const data = {
            M_FinancialYearID: year.ID,
            M_MonthID: monthId,
            ReadingDate: ReadingData,
            RawWaterReceivedFromDam: QuantityOfWaterInputField.rawWaterReceivedFromDam,
            RawWaterSuppliedToMJP: QuantityOfWaterInputField.rawWaterSuppliedToMJP,
            NetRawWaterSuppliedToNMMC: QuantityOfWaterInputField.netRawWaterSuppliedToNMMC,
            TreatmentLossInMLD: QuantityOfWaterInputField.treatmentLossInMLD,
            QuantityofPureWater: QuantityOfWaterInputField.quantityofPureWater,
            M_UserID: UserID,
            token: token,
            handleIsPost: handleIsPost,
            handleOnCloseClick: handleOnCloseClick,
            setloading: setloading
        }
        // console.log('jhuhuihiuh',data)
        dispatch(WTPQuantityOfWaterPostDataAPI({ data }))
    }

    return (

        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick} contentStyle={{ width: '70vw' }}
        >
            <div className="area_pop modal-dialog modal-dialog-scrollable modal-xl" style={{ alignItems: "center", justifyContent: 'center' }}>
                <div className="modal-content road_ward_modal">
                    <div className="modal-header pl-4 p-1">
                        <h4 className="modal-title" id="staticBackdropLabel" style={{ fontSize: '19px' }}>Quantity Of Water</h4>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>
                    {loading && <Loading />}
                    <div className="modal-body">
                        <div className='inner-modal-body'>
                            <div className="row details-row">
                                <h5 className="modal-title" id="staticBackdropLabel">Parameter </h5>
                                <div className="col-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"> <b>Date </b></label>
                                        <input type="date"
                                            className="form-control"
                                            id="readingDate"
                                            value={ReadingData}
                                            max={moment().format('YYYY-MM-DD')}
                                            onChange={(e) => (setReadingData(e.target.value))}
                                        />

                                    </div>
                                </div>

                                <div className="col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Raw Water Received From Dam </b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="rawWaterReceivedFromDam"
                                            aria-describedby="emailHelp"
                                            name='rawWaterReceivedFromDam'
                                            value={QuantityOfWaterInputField.rawWaterReceivedFromDam}
                                            onChange={(e) => handleInputChange(e)}
                                        />

                                    </div>
                                </div>

                                <div className="col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Raw Water Supplied To MJP </b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="rawWaterSuppliedToMJP"
                                            aria-describedby="emailHelp"
                                            name='rawWaterSuppliedToMJP'
                                            value={QuantityOfWaterInputField.rawWaterSuppliedToMJP}
                                            onChange={(e) => handleInputChange(e)}
                                        />

                                    </div>
                                </div>

                                <div className="col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Net Raw Water Supplied To NMMC </b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="netRawWaterSuppliedToNMMC"
                                            aria-describedby="emailHelp"
                                            name='netRawWaterSuppliedToNMMC'
                                            value={QuantityOfWaterInputField.netRawWaterSuppliedToNMMC}
                                            onChange={(e) => handleInputChange(e)}
                                        />

                                    </div>
                                </div>

                                <div className="col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Treatment Loss in MLD </b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="treatmentLossInMLD"
                                            aria-describedby="emailHelp"
                                            name='treatmentLossInMLD'
                                            value={QuantityOfWaterInputField.treatmentLossInMLD}
                                            onChange={(e) => handleInputChange(e)}
                                        />

                                    </div>
                                </div>

                                <div className="col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Quantity of Pure Water Pump From Pure Water Sump </b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="quantityofPureWater"
                                            aria-describedby="emailHelp"
                                            name='quantityofPureWater'
                                            value={QuantityOfWaterInputField.quantityofPureWater}
                                            onChange={(e) => handleInputChange(e)}
                                        />

                                    </div>
                                </div>

                            </div>
                            <div className="col-12 col-lg-12">
                                <div className="btn-action d-flex justify-content-end mt-lg-3">
                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"
                                        onClick={() => handleSubmit()}
                                    >{Flag === "Update" ? "Update" : "Save"} </button>
                                    <button type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* )} */}
        </Popup>
    )

}